import $ from 'jquery';
import { waitForPromise } from '@ember/test-waiters';
import ENV from '../config/environment';

// You can define any private functions here
var executeFunctionByName = function (functionName, context /*, args */) {
  var args = [].slice.call(arguments).splice(2);
  var namespaces = functionName.split('.');
  var func = namespaces.pop();
  for (var i = 0; i < namespaces.length; i++) {
    context = context[namespaces[i]];
  }
  return context[func].apply(this, args);
};

$.fn.exists = function () {
  return this.length !== 0;
};

export default {
  // Populate this object with all the utilities that we need.
  executeFunctionsByStringName: function (context, validationFunctionNames, isReturnFunction) {
    var args = [].slice.call(arguments).splice(3);
    //var result;
    if (isReturnFunction) {
      return executeFunctionByName(validationFunctionNames[0], context, args[0], args[1], args[2]);
    } else {
      for (var i = 0; i < validationFunctionNames.length; i++) {
        executeFunctionByName(validationFunctionNames[i], context, args[0], args[1], args[2]);
      }
    }
  },

  findBootstrapEnvironment: function () {
    var envs = ['xs', 'sm', 'md', 'lg', 'xl'];

    var $el = $('<div>');
    $el.appendTo($('body'));

    for (var i = envs.length - 1; i >= 0; i--) {
      var env = envs[i];

      $el.addClass('d-' + env + '-none');
      if ($el.is(':hidden')) {
        $el.remove();
        return env;
      }
    }
  },

  parse: function (str) {
    if (typeof str !== 'string') {
      return {};
    }

    str = str.trim().replace(/^(\?|#|&)/, '');

    if (!str) {
      return {};
    }

    return str.split('&').reduce(function (ret, param) {
      var parts = param.replace(/\+/g, ' ').split('=');
      var key = parts[0];
      var val = parts[1];

      key = decodeURIComponent(key);

      // missing `=` should be `null`:
      // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
      val = val === undefined ? null : decodeURIComponent(val);

      if (!Object.prototype.hasOwnProperty.call(ret, key)) {
        ret[key] = val;
      } else if (Array.isArray(ret[key])) {
        ret[key].push(val);
      } else {
        ret[key] = [ret[key], val];
      }

      return ret;
    }, {});
  },

  stringify: function (obj) {
    return obj
      ? Object.keys(obj)
          .sort()
          .map(function (key) {
            var val = obj[key];

            if (Array.isArray(val)) {
              return val
                .sort()
                .map(function (val2) {
                  //return strictUriEncode(key) + '=' + strictUriEncode(val2);
                  return encodeURI(key) + '=' + encodeURI(val2);
                })
                .join('&');
            }

            //return strictUriEncode(key) + '=' + strictUriEncode(val);
            return encodeURI(key) + '=' + encodeURI(val);
          })
          .join('&')
      : '';
  },

  loadSvg: function (svg, container, anonFunc) {
    const url =
      ENV.rootURL[ENV.rootURL.length - 1] === '/' ? `${ENV.rootURL}svgs/${svg}` : `${ENV.rootURL}/svgs/${svg}`;
    waitForPromise(
      fetch(url)
        .then((response) => {
          if (response.status >= 400) {
            throw `SVG Load Failed for ${url} with ${response.status}`;
          }
          return response.text();
        })
        .then((svg) => {
          container.html(svg);
          anonFunc();
        }),
    );
    //require(["text!assets/svgs/" + svg], function (svg) {
    //});
  },

  getAnalogBaseURL: function () {
    return location.host.indexOf('www-local') !== -1 ? '//www.analog.com' : location.protocol + '//' + location.host;
  },
};
